
import { Question } from '../types';

export const qur101SababNuzulQuestions: Question[] = [
  {
    id: 'qur061',
    text: 'What is the meaning of "Sabab un-Nuzūl"?',
    type: 'multiple',
    options: [
      { id: 'a', text: 'The reason for revelation', isCorrect: true },
      { id: 'b', text: 'The cause of revelation', isCorrect: true },
      { id: 'c', text: 'The occasion of revelation', isCorrect: true },
      { id: 'd', text: 'The timing of compilation', isCorrect: false }
    ],
    explanation: 'Sabab un-Nuzūl literally means "the reason for revelation," but it encompasses the cause, reason, or occasion—the circumstances—of the revelation of particular verses. Understanding these circumstances helps provide context for proper interpretation of the Qur\'ān.',
    topic: 'qur101'
  },
  {
    id: 'qur062',
    text: 'What types of verses might not have a specific Sabab un-Nuzūl?',
    type: 'single',
    options: [
      { id: 'a', text: 'Informative verses not tied to specific events', isCorrect: true },
      { id: 'b', text: 'Verses about the afterlife', isCorrect: false },
      { id: 'c', text: 'Verses containing legal rulings', isCorrect: false },
      { id: 'd', text: 'Verses mentioning previous prophets', isCorrect: false }
    ],
    explanation: 'Informative verses that are not tied to specific events typically don\'t have a specific Sabab un-Nuzūl. These verses were revealed to provide general guidance, knowledge, or teachings rather than in response to particular circumstances or questions.',
    topic: 'qur101'
  },
  {
    id: 'qur063',
    text: 'What is the significance of understanding the circumstances of Āl-i-ʿImrān verse 159 (3:159)?',
    type: 'multiple',
    options: [
      { id: 'a', text: 'It shows the Prophet\'s ﷺ forgiveness of the archers at Uḥud', isCorrect: true },
      { id: 'b', text: 'It reveals divine approval of the Prophet\'s ﷺ merciful leadership', isCorrect: true },
      { id: 'c', text: 'It demonstrates how forgiveness preserves community cohesion', isCorrect: true },
      { id: 'd', text: 'It establishes prayer requirements during battle', isCorrect: false }
    ],
    explanation: 'Understanding the circumstances of Āl-i-ʿImrān verse 159 (3:159) reveals that it came down as a result of the Prophet\'s ﷺ forgiveness of the archers who abandoned their post at the Battle of Uḥud. This shows divine approval of the Prophet\'s merciful leadership and demonstrates how forgiveness preserves community cohesion, even after a serious mistake that cost many lives.',
    topic: 'qur101'
  },
  {
    id: 'qur064',
    text: 'What event led to the revelation of Sūrat ul-Kahf verses 23-24 (18:23-24)?',
    type: 'single',
    options: [
      { id: 'a', text: 'The Prophet ﷺ promised information without saying "in shā Allāh"', isCorrect: true },
      { id: 'b', text: 'The Prophet ﷺ forgot to perform a prayer on time', isCorrect: false },
      { id: 'c', text: 'A companion made a promise he couldn\'t keep', isCorrect: false },
      { id: 'd', text: 'The Muslims were planning battle strategy', isCorrect: false }
    ],
    explanation: 'Sūrat ul-Kahf verses 23-24 were revealed after the Jews asked the Prophet ﷺ for certain information, and he said "I will definitely bring it tomorrow" without saying "in shā Allāh" (if Allah wills). As a result, revelation was delayed for 14 days, and these verses came to instruct that one should always acknowledge Allah\'s will in future plans.',
    topic: 'qur101'
  },
  {
    id: 'qur065',
    text: 'How does Sabab un-Nuzūl help us understand the procedure behind commandments in Islam?',
    type: 'single',
    options: [
      { id: 'a', text: 'It reveals the gradual implementation of rulings', isCorrect: true },
      { id: 'b', text: 'It shows which companions were consulted on rulings', isCorrect: false },
      { id: 'c', text: 'It indicates which rulings were temporary', isCorrect: false },
      { id: 'd', text: 'It specifies punishments for breaking commandments', isCorrect: false }
    ],
    explanation: 'Sabab un-Nuzūl helps us understand the procedure behind commandments by revealing their gradual implementation. For example, the prohibition of intoxicants came in three stages: first indicating their harm exceeds their benefit (2:219), then forbidding prayer while intoxicated (4:43), and finally complete prohibition (5:90). Without this context, one might misinterpret the earlier, more lenient verses as still applicable.',
    topic: 'qur101'
  },
  {
    id: 'qur066',
    text: 'How does Sabab un-Nuzūl help prevent misinterpretation of verses like "Wherever you turn, there is the Face of Allah" (2:115)?',
    type: 'single',
    options: [
      { id: 'a', text: 'It shows the verse addresses changing the qiblah direction, not praying in any direction', isCorrect: true },
      { id: 'b', text: 'It indicates the verse was abrogated by later revelations', isCorrect: false },
      { id: 'c', text: 'It proves the verse was only meant metaphorically', isCorrect: false },
      { id: 'd', text: 'It demonstrates the verse applies only to travelers', isCorrect: false }
    ],
    explanation: 'Sabab un-Nuzūl prevents misinterpretation of 2:115 by revealing it was revealed in the context of changing the qiblah from Baitul Maqdis to the Ka\'bah. Some people claimed they couldn\'t feel a spiritual connection facing any direction but Baitul Maqdis. The verse affirms that Allah is everywhere, but doesn\'t mean one can pray in any direction as some have incorrectly claimed.',
    topic: 'qur101'
  },
  {
    id: 'qur067',
    text: 'How does understanding the circumstances of Sūrat ul-Anfāl 8:17-18 clarify its meaning?',
    type: 'single',
    options: [
      { id: 'a', text: 'It refers to events at the Battle of Badr where divine assistance was evident', isCorrect: true },
      { id: 'b', text: 'It refers to metaphorical arrows of speech and argument', isCorrect: false },
      { id: 'c', text: 'It speaks about the conquest of Makkah', isCorrect: false },
      { id: 'd', text: 'It concerns a specific companion\'s archery skills', isCorrect: false }
    ],
    explanation: 'Understanding the circumstances of Sūrat ul-Anfāl 8:17-18 clarifies that these verses refer to events at the Battle of Badr, where people witnessed enemies dying. The verses emphasize that sometimes people put in little effort, but Allah magnifies the results and rewards. Without knowing this context (sabab un-nuzūl), the reference to throwing and Allah\'s involvement would be unclear.',
    topic: 'qur101'
  },
  {
    id: 'qur068',
    text: 'What does "clear wording" in hadith mean when identifying Sabab un-Nuzūl?',
    type: 'multiple',
    options: [
      { id: 'a', text: 'Explicit statements like "This was sent in..."', isCorrect: true },
      { id: 'b', text: 'Phrases like "Because xyz... this was revealed"', isCorrect: true },
      { id: 'c', text: 'Direct mention of the revelation\'s cause', isCorrect: true },
      { id: 'd', text: 'Any hadith mentioning the Prophet ﷺ reciting a verse', isCorrect: false }
    ],
    explanation: '"Clear wording" in hadith when identifying Sabab un-Nuzūl refers to explicit statements that directly link a cause to a revelation, such as "This verse was sent in this circumstance" or "Because of this event, this verse was revealed." These explicit narrations leave no ambiguity about the connection between the event and the revelation.',
    topic: 'qur101'
  },
  {
    id: 'qur069',
    text: 'What does "unclear wording" in hadith mean when identifying Sabab un-Nuzūl?',
    type: 'multiple',
    options: [
      { id: 'a', text: 'General statements like "It was revealed in..."', isCorrect: true },
      { id: 'b', text: 'No explicit mention of an āyah or reason', isCorrect: true },
      { id: 'c', text: 'Requiring inference based on timing or context', isCorrect: true },
      { id: 'd', text: 'Hadith from unreliable narrators', isCorrect: false }
    ],
    explanation: '"Unclear wording" in hadith when identifying Sabab un-Nuzūl refers to general statements that don\'t explicitly connect a cause to a revelation, such as "It was revealed in..." without mentioning a specific reason. These narrations require inference based on timing, context, or other evidence to establish the connection between events and revelations.',
    topic: 'qur101'
  },
  {
    id: 'qur070',
    text: 'How can we determine that Sūrat Ṭāhā was revealed before the migration to Abyssinia without an explicit narration?',
    type: 'single',
    options: [
      { id: 'a', text: 'Through inference based on \'Umar ibn al-Khaṭṭāb\'s conversion story', isCorrect: true },
      { id: 'b', text: 'By its position in the compiled Qur\'ān', isCorrect: false },
      { id: 'c', text: 'Through linguistic analysis of its vocabulary', isCorrect: false },
      { id: 'd', text: 'By comparing its themes to known early surahs', isCorrect: false }
    ],
    explanation: 'We can determine that Sūrat Ṭāhā was revealed before the migration to Abyssinia through inference, even without an explicit narration. This is because we know the surah was revealed before \'Umar ibn al-Khaṭṭāb converted to Islam (as evidenced by the narration of him hearing women reciting it when he was on his way to confront the Prophet ﷺ), and \'Umar\'s conversion preceded the migration to Abyssinia.',
    topic: 'qur101'
  }
];
